async function sortAllSwatchesByLightness() {
  const swatchesContainers = document.querySelectorAll('.cc-swatches');

  const getLightness = (r, g, b) => {
    const [rNorm, gNorm, bNorm] = [r, g, b].map(c => c / 255);
    const max = Math.max(rNorm, gNorm, bNorm);
    const min = Math.min(rNorm, gNorm, bNorm);
    return (max + min) / 2;
  };

  const colorCache = {};

  // Load cache from localStorage if exists
  const localColorCache = localStorage.getItem('swatchColorCache');
  if (localColorCache) {
    try {
      Object.assign(colorCache, JSON.parse(localColorCache));
    } catch (e) {
      console.warn('Failed to parse swatch color cache:', e);
    }
  }

  const swatchWorkerBlob = new Blob([`
    self.onmessage = async function (e) {
      const { imageUrl } = e.data;
      try {
        const response = await fetch(imageUrl, { mode: 'cors' });
        const blob = await response.blob();
        const imgBitmap = await createImageBitmap(blob);

        const canvas = new OffscreenCanvas(imgBitmap.width, imgBitmap.height);
        const ctx = canvas.getContext('2d');
        ctx.drawImage(imgBitmap, 0, 0);

        const imageData = ctx.getImageData(0, 0, imgBitmap.width, imgBitmap.height);
        const { data } = imageData;
        let r = 0, g = 0, b = 0;

        for (let i = 0; i < data.length; i += 4) {
          r += data[i];
          g += data[i + 1];
          b += data[i + 2];
        }

        const pixelCount = data.length / 4;
        const avgColor = [
          Math.round(r / pixelCount),
          Math.round(g / pixelCount),
          Math.round(b / pixelCount)
        ];

        self.postMessage({ imageUrl, avgColor });
      } catch (err) {
        self.postMessage({ imageUrl, error: err.toString() });
      }
    };
  `], { type: 'application/javascript' });

  const swatchWorkerUrl = URL.createObjectURL(swatchWorkerBlob);
  const worker = new Worker(swatchWorkerUrl);

  const getAverageColor = (imageUrl) => {
    if (colorCache[imageUrl]) {
      return Promise.resolve(colorCache[imageUrl]);
    }

    return new Promise((resolve, reject) => {
      const handleMessage = (e) => {
        if (e.data.imageUrl !== imageUrl) return;
        worker.removeEventListener('message', handleMessage);

        if (e.data.error) {
          reject(e.data.error);
        } else {
          colorCache[imageUrl] = e.data.avgColor;

          // Persist to localStorage
          try {
            localStorage.setItem('swatchColorCache', JSON.stringify(colorCache));
          } catch (err) {
            console.warn('LocalStorage full or error saving swatchColorCache', err);
          }

          resolve(e.data.avgColor);
        }
      };

      worker.addEventListener('message', handleMessage);
      worker.postMessage({ imageUrl });
    });
  };

  for (const container of swatchesContainers) {
    const swatches = Array.from(container.querySelectorAll('li'));
    const swatchesWithLightness = [];

    for (let i = 0; i < swatches.length; i++) {
      const swatch = swatches[i];
      const anchor = swatch.querySelector('a');
      if (!anchor) {
        swatchesWithLightness.push({ swatch, lightness: 1 });
        continue;
      }

      let imageUrlMatch = anchor.getAttribute('data-bgset');

      if (imageUrlMatch) {
        imageUrlMatch = imageUrlMatch.startsWith('//') ? 'https:' + imageUrlMatch : imageUrlMatch;
        imageUrlMatch = imageUrlMatch.replace('_48x48_', '_4x4_');
      } else {
        const backgroundImage = anchor.style.backgroundImage;
        const match = backgroundImage.match(/url\\(["']?(.*?)["']?\\)/);
        imageUrlMatch = match ? match[1] : null;
      }

      if (!imageUrlMatch) {
        swatchesWithLightness.push({ swatch, lightness: 1 });
        continue;
      }

      try {
        const [r, g, b] = await getAverageColor(imageUrlMatch);
        const lightness = getLightness(r, g, b);
        swatchesWithLightness.push({ swatch, lightness });
      } catch (err) {
        console.warn(err);
        swatchesWithLightness.push({ swatch, lightness: 1 });
      }

      if (i % 10 === 0) {
        await new Promise(res => setTimeout(res, 0));
      }
    }

    swatchesWithLightness
      .sort((a, b) => b.lightness - a.lightness)
      .forEach(({ swatch }) => container.appendChild(swatch));
  }

  setTimeout(reOrderHidden, 500);
}

function reOrderHidden() {
  const allUl = document.querySelectorAll('ul.cc-swatches');

  allUl.forEach(ul => {
    const allLi = ul.querySelectorAll('li');
    let hiddenCount = 0;

    allLi.forEach(li => {
      if (li.classList.contains('hidden')) hiddenCount++;
      li.classList.remove('hidden');
    });

    const totalLi = allLi.length;
    for (let i = totalLi - hiddenCount; i < totalLi; i++) {
      allLi[i].classList.add('hidden');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    sortAllSwatchesByLightness();
  }, 1000);
});